<template lang="pug">
  router-view
</template>

<script>
import Vue from 'vue'
import VueAWN from 'vue-awesome-notifications'

export default {
  created () {
    const {lang} = this.$route.params
    this.$moment.locale(lang)

    Vue.use(VueAWN, {
      position: 'top-right',
      duration: 5000,
      label: {
        confirm: this.$t('has_new_message')
      },
      icons: {
        info: 'info'
      },
      modal: {
        okLabel: this.$t('submit'),
        cancelLabel: this.$t('cancel')
      }
    })
  }
}
</script>
